/* @generated */

// src/assets/ui-icon/line/attach.tsx
import * as React from "react";
var AttachLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M17 8.998v5.567c-.022 1.655-.694 2.926-1.723 3.764-1.012.823-2.322 1.193-3.592 1.17-1.27-.024-2.563-.442-3.549-1.273-1-.844-1.652-2.091-1.636-3.675V8.239c.016-1.247.484-2.221 1.236-2.868.737-.633 1.688-.901 2.6-.868 1.803.065 3.723 1.359 3.664 3.755v6.002c0 .708-.274 1.293-.73 1.69a2.3 2.3 0 0 1-1.472.55h-.092a2.321 2.321 0 0 1-1.5-.569c-.446-.397-.715-.978-.706-1.676V8.998H11v5.275c-.004.28.093.439.204.538.127.113.32.188.54.19.22.002.413-.07.54-.181.112-.098.216-.262.216-.56V8.228c.037-1.374-1.013-2.183-2.218-2.226-.595-.022-1.16.155-1.568.507-.394.338-.702.888-.714 1.744v6.31c-.012 1.127.435 1.953 1.103 2.517.685.577 1.632.9 2.61.919.977.018 1.924-.27 2.617-.834.674-.548 1.153-1.393 1.17-2.615V8.998H17Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  AttachLine
};
